module.exports = __webpack_public_path__ + "media/images/flags/16/Italy-ea822acbd77a3d9fbe30723642f519e1.png";